<template>
  <div class="hot-wrapper">
    <div class="hot-tab">
      <ul>
        <li
          uigs="tab_0"
          class="cur"
        >
          热搜
        </li>
      </ul>
    </div>
    <ul class="hot-list">
      <li
        v-for="(item, index) in hotList"
        :key="index"
        :uigs="'in_search_hotword_' + item.name"
      >
        <a :href="item.url">{{ item.name }}</a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    hotList: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss">
@import '../../../asset/css/abstracts/mixin.scss';
.hot-wrapper {
  margin: 5px;
  padding: 0 14px;
}

.hot-tab {
  overflow-x: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
  white-space: nowrap;
  li {
    display: inline-block;
    height: 27px;
    margin-left: 20px;
    position: relative;
    color: #555;
    font-size: 15px;
    line-height: 25px;

    &.cur {
      color: #222;
      font-weight: bold;

      &:after {
        content: '';
        @extend %-horizontal-center;
        bottom: 0;
        background: #000;
        width: 20px;
        height: 2px;
        border-radius: 1px;
      }
    }

    &:first-child {
      margin-left: 0;
    }
  }
}

.hot-list {
  margin-top: 15px;

  li {
    width: 50%;
    float: left;
    margin-bottom: 20px;
    height: 20px;
    line-height: 20px;
    font-size: 15px;
    counter-increment: rank-best;
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    &:before {
      content: counter(rank-best);
      display: block;
      color: #cccccc;
      width: 17px;
      margin-right: 4px;
      font-weight: bold;
      flex: none;
    }

    &:first-child:before {
      color: #fa4b0c;
    }
    &:nth-of-type(2):before {
      color: #ff7c24;
    }
    &:nth-of-type(3):before {
      color: #ffa100;
    }

    a {
      color: #222;
      @include line-clip(1);
      flex: auto;
    }
  }
}
</style>
